import React from 'react'; // eslint-disable-line

const StatusCircle = (props) => {
    return (
        <svg height="9" width="9">
            <circle cx="4.5" cy="4.5" r="4.5" fill={props.color} />
        </svg>
    );
};

export default StatusCircle;
